import { React, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

import MemberShipInfoEditView from './MemberShipInfoEditView.js';
import FetchModule from '../../../../Share/Network/FetchModule.js';
import { useLanguage } from '../../../../../Context/LanguageContext';

export default function MemberShipEditModal(props) {
  const { className, exitClickFn, data, memberId, totalPoint, index, userData } = props;

  const [isLinkPay, setIsLinkPay] = useState(false);
  const [originalApprovalDate, setOriginalApprovalDate] = useState('');
  const [originalCardPrice, setOriginalCardPrice] = useState('');

  const history = useHistory();
  const { t } = useLanguage();

  const EditRef = useRef();

  useEffect(() => {
    // 링크페이로 결제한 데이터의 경우 //
    if (data[index].merchantUid.split('-')[2] === '1' || data[index].merchantUid.split('-')[2] === '2') {
      setOriginalApprovalDate(moment(data[index].approvalDate).format('YYYY.MM.DD'));
      setOriginalCardPrice(data[index].cardPrice);
      setIsLinkPay(true);
    }

  }, [])

  function exitClick() {
    exitClickFn(className);
  }

  function saveClick() {
    const id = data[index].usageId;
    const storeId = window.sessionStorage.getItem('StoreId');
    const merchantUids = data[index].merchantUids;
    const memberShipId = EditRef.current.getMemberShipId();
    const startDate = EditRef.current.getStartDate();
    const endDate = EditRef.current.getEndDate();
    const approvalDate = EditRef.current.getApprovalDate();
    const cashPrice = EditRef.current.getCashPrice();
    const cardPrice = EditRef.current.getCardPrice();
    const discountPrice = EditRef.current.getDiscountPrice();
    const notReceivedPrice = EditRef.current.getNotReceivedPrice();
    const point = EditRef.current.getPoint();
    const totalMax = EditRef.current.getTotalMaxCount();

    if (memberShipId === 0 || memberShipId === -1) {
      alert(t('memberDetail.membershipEditModal.alertSelectMembershipPlease'));
      return;
    }

    // 링크페이로 결제한 내역의 경우 결제일과 카드결제금액은 변경할 수 없음 //
    if (isLinkPay) {
      if (originalApprovalDate !== approvalDate) {
        alert(t('memberDetail.membershipEditModal.alertLinkpayDateCannotChange'));
        EditRef.current.setApprovalDate(originalApprovalDate);
        return;
      }
      else if (originalCardPrice !== cardPrice) {
        alert(t('memberDetail.membershipEditModal.alertLinkpayCardCannotChange'));
        EditRef.current.setCardPrice(originalCardPrice);
        return;
      }
    }

    const requestData = {
      id: id,
      storeId: storeId,
      memberId: memberId,
      merchantUid: merchantUids,
      memberShipId: memberShipId,
      startDate: startDate.replaceAll('.', '-') + 'T00:00:00',
      endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
      approvalDate: approvalDate.replaceAll('.', '-') + 'T00:00:00',
      cashPrice: cashPrice,
      cardPrice: cardPrice,
      discountPrice: discountPrice,
      notReceivedPrice: notReceivedPrice,
      point: point,
      totalMax: parseInt(totalMax)
      // 미수금 넣기 //
    }
    
       
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/usage/modify', 'POST', requestData);
       
        if (responseData.status === 200) {
          alert(t('memberDetail.membershipEditModal.alertSaveComplete'));
          exitClickFn(className);
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/login');
        }
        else alert(t('memberDetail.courseAddModal.alertDataLoadFailed'));
      }
    )();
  }

  return (
    <TotalModalWrapper>
      <ModalView>
        <MemberShipInfoEditView ref={EditRef} data={data} index={index} totalPoint={totalPoint} userData={userData}/>
        <ButtonWrapper>
          <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
          <SaveButton onClick={saveClick}>{t('memberDetail.membershipEditModal.btnSave')}</SaveButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}


const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;


  width: 1020px;
  height: 610px;


  border-radius: 12px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: 16px;

  margin: 36px 0 28px 802px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 40px;

  border-radius: 5px;
  background-color: #F5F6F8;
  
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 5px;
  background-color: #5BD98A;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #2BCB67;
  }
`;